import { RefObject, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { GrappleModule } from "../../interfaces/api/GrappleModule";
import { LowerBracket } from "../../interfaces/api/LowerBracket";
import { MachineFixing } from "../../interfaces/api/MachineFixing";
import { Rototilt } from "../../interfaces/api/Rototilt";
import { UpperBracket } from "../../interfaces/api/UpperBracket";
import { MachineFixingType } from "../../shared/enums/MachineFixingType";
import { ProductCategory } from "../../shared/enums/ProductCategory";
import { filterHelper } from "../../shared/helpers/filterHelper";
import { productCardHelper } from "../../shared/helpers/productCardHelper";
import ProductCard from "../ProductCard/ProductCard";
import GrappleModules from "../Products/GrappleModules";
import LowerBrackets from "../Products/LowerBrackets";
import UpperBrackets from "../Products/UpperBrackets";
import { localImages } from "../shared/localImages";
import MachineFixingList from "./MachineFixingList";
import "./MachineFixings.scss";

interface MachineFixingsProps {
  grappleModules?: GrappleModule[];
  isNoneGrappleModuleSelected?: boolean;
  lowerBrackets?: LowerBracket[];
  machineFixings: MachineFixing[];
  onGrappleModuleChange(grappleModule: GrappleModule): void;
  onLowerBracketChange(lowerBracket: LowerBracket): void;
  onMachineFixingChange(machineFixing: MachineFixing): void;
  onMachineFixingTypeChange(machineFixingType: MachineFixingType): void;
  onNoneGrapppleModuleChange(): void;
  onUpperBracketChange(upperBracket: UpperBracket): void;
  productCategory: ProductCategory;
  refGrappleModules: RefObject<HTMLDivElement>;
  refLowerBrackets: RefObject<HTMLDivElement>;
  refMachineFixingList: RefObject<HTMLDivElement>;
  refMachineFixings: RefObject<HTMLDivElement>;
  refUpperBrackets: RefObject<HTMLDivElement>;
  selectedGrappleModule?: GrappleModule;
  selectedLowerBracket?: LowerBracket;
  selectedMachineFixing: MachineFixing;
  selectedMachineFixingType: MachineFixingType;
  selectedUpperBracket?: UpperBracket;
  upperBrackets?: UpperBracket[];
  selectedTiltrotator: Rototilt;
}

const MachineFixings = ({
  grappleModules = [],
  isNoneGrappleModuleSelected,
  lowerBrackets = [],
  machineFixings,
  onGrappleModuleChange,
  onLowerBracketChange,
  onMachineFixingChange,
  onMachineFixingTypeChange,
  onNoneGrapppleModuleChange,
  onUpperBracketChange,
  productCategory,
  refGrappleModules,
  refMachineFixingList,
  refMachineFixings,
  refLowerBrackets,
  refUpperBrackets,
  selectedGrappleModule,
  selectedLowerBracket,
  selectedMachineFixingType,
  selectedMachineFixing,
  selectedUpperBracket,
  selectedTiltrotator,
  upperBrackets = [],
}: MachineFixingsProps) => {
  const [machineFixningsS, setMachineFixningsS] = useState<MachineFixing[]>([]);
  const [machineFixningsQC, setMachineFixningsQC] = useState<MachineFixing[]>(
    []
  );
  const { t } = useTranslation(["machinefixings"]);

  useEffect(() => {
    const sFixings = machineFixings.filter(filterHelper.filterMachineFixningsS);
    const qcFixings = machineFixings.filter(
      filterHelper.filterMachineFixningsQC
    );

    setMachineFixningsS(sFixings);
    setMachineFixningsQC(qcFixings);
  }, [machineFixings]);

  const onChange = (machineFixingType: MachineFixingType) => {
    onMachineFixingTypeChange(machineFixingType);
  };

  const isSelected = (machineFixingType: MachineFixingType): boolean =>
    machineFixingType === selectedMachineFixingType;

  const showGrappleModule = () => {
    if(!selectedTiltrotator) {
      return false;
    }
    if (selectedMachineFixingType === MachineFixingType.None) {
      return false;
    }

    if (selectedMachineFixing && selectedLowerBracket) {
      return true;
    }

    if (selectedUpperBracket && selectedLowerBracket) {
      return true;
    }

    return false;
  };
    if (selectedMachineFixing) {
        const filterdLowerBrackets: LowerBracket[] = [];
        lowerBrackets.forEach((lowerbracket) => {
            if (selectedMachineFixing.compatibleLowerBrackets.indexOf(lowerbracket.name) > -1)
            //if (["S40", "S45", "S50"].indexOf(lowerbracket.name) > -1)
                filterdLowerBrackets.push(lowerbracket);
        })
        lowerBrackets = filterdLowerBrackets;
    }

  return (
    <>
      <div ref={refMachineFixings} className="machineFixings">
        {machineFixningsS && machineFixningsS.length > 0 && (
          <ProductCard
            content=""
            height={productCardHelper.height}
            localImage={localImages.MC_S}
            isSelected={isSelected(MachineFixingType.SFixing)}
            onChange={() => onChange(MachineFixingType.SFixing)}
            preContent={`${machineFixningsS ? machineFixningsS.length : 0} ${t(
              "pieces",
              { ns: "metrics" }
            )}`}
            title={`${t("sfixing.sfixing")}`}
            addTooltip={false}
            tooltipText=""
          />
        )}
        {machineFixningsQC && machineFixningsQC.length > 0 && (
          <ProductCard
            content=""
            height={productCardHelper.height}
            localImage={localImages.QC}
            isSelected={isSelected(MachineFixingType.QCFixing)}
            onChange={() => onChange(MachineFixingType.QCFixing)}
            preContent={`${
              machineFixningsQC ? machineFixningsQC.length : 0
            } ${t("pieces", { ns: "metrics" })}`}
            title={`${t("qcfixing.qcfixing")}`}
            addTooltip={false}
            tooltipText=""
          />
        )}
        {productCategory === ProductCategory.Tiltrotator && (
          <ProductCard
            content=""
            height={productCardHelper.height}
            localImage=""
            isSelected={isSelected(MachineFixingType.NoMachineFixing)}
            onChange={() => onChange(MachineFixingType.NoMachineFixing)}
            preContent=""
            title={`${t("nomachinefixing")}`}
            addTooltip={false}
            tooltipText=""
          />
        )}
      </div>
      <div>
        {selectedMachineFixingType === MachineFixingType.SFixing && (
          <MachineFixingList
            onChange={onMachineFixingChange}
            machineFixnings={machineFixningsS}
            refMachineFixingList={refMachineFixingList}
            selectedMachineFixing={selectedMachineFixing}
          />
        )}
        {selectedMachineFixingType === MachineFixingType.QCFixing && (
          <MachineFixingList
            onChange={onMachineFixingChange}
            machineFixnings={machineFixningsQC}
            refMachineFixingList={refMachineFixingList}
            selectedMachineFixing={selectedMachineFixing}
          />
        )}
        {(selectedMachineFixingType === MachineFixingType.SFixing ||
          selectedMachineFixingType === MachineFixingType.QCFixing) &&
          selectedMachineFixing && selectedTiltrotator && (
            <LowerBrackets
              lowerBrackets={lowerBrackets}
              refLowerBrackets={refLowerBrackets}
              onChange={onLowerBracketChange}
              selectedLowerBracket={selectedLowerBracket}
            />
          )}
        {selectedMachineFixingType === MachineFixingType.NoMachineFixing && (
          <>
            <UpperBrackets
              onChange={onUpperBracketChange}
              refUpperBrackets={refUpperBrackets}
              selectedUpperBracket={selectedUpperBracket}
              upperBrackets={upperBrackets}
            />
            {selectedUpperBracket && (
              <LowerBrackets
                lowerBrackets={lowerBrackets}
                refLowerBrackets={refLowerBrackets}
                onChange={onLowerBracketChange}
                selectedLowerBracket={selectedLowerBracket}
              />
            )}
          </>
        )}
        {showGrappleModule() === true && (
          <GrappleModules
            grappleModules={grappleModules}
            isNoneSelected={isNoneGrappleModuleSelected}
            onChange={onGrappleModuleChange}
            onNoneChange={onNoneGrapppleModuleChange}
            refGrappleModules={refGrappleModules}
            selectedGrappleModule={selectedGrappleModule}
          />
        )}
      </div>
    </>
  );
};

export default MachineFixings;
